import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateTemplatePayload } from '@app-store/slices/templates/create'

interface TaskAction extends Action {
    payload: ICreateTemplatePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.templates.create

function* createTemplateSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/notifications/templates`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload.sagaCB?.onSuccess(response.result.data))
            notification.success({
                message: 'Template created successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createTemplateSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createTemplateSagaTask)
}

export default createTemplateSaga
